import React from 'react';
import Link from 'react-router/lib/Link';
import './CaseMenuMobile.less';

function Item({data: {key, title}}) {
  const url = `/case/${key}`;
  return <Link to={url}>{title}</Link>;
}

function CaseMenuMobile({menu}) {
  return (
    <div className='CaseMenuMobile'>
      {menu.map(item => <Item key={item.key} data={item} />)}
    </div>
  );
}

export default CaseMenuMobile;


// WEBPACK FOOTER //
// ./src/routes/Case/CaseMenuMobile.js